import React from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import { makeStyles } from "@mui/styles";
import clsx from "clsx";

export const MEDIUM_BUTTON_SIZE = 150;

const primaryButtonStyles = makeStyles((theme) => ({
    button: {
        "&:disabled": {
            color: "#fff",
            background: theme.palette.primary.disabled,
        },
    },
    fullWidth: {
        width: "100% !important",
    },

    text: {
        width: MEDIUM_BUTTON_SIZE,
        height: 55,
        padding: "8px 10px",
        lineHeight: 1.3,
        boxShadow: "0 2px 4px 0 rgba(83, 83, 83, 0.5)",
    },
    textPrimary: {
        color: "#fff !important",
        background: `linear-gradient(129deg, ${theme.palette.primary.light} 0%, ${theme.palette.primary.dark}) 80%`,

        "&:hover, &:active": {
            color: "#fff",
            background: `linear-gradient(129deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.dark}) 80%`,
        },
    },
    textSizeSmall: {
        fontSize: theme.typography.button.fontSize,
    },
    textSizeLarge: {
        fontSize: theme.typography.button.fontSize,
    },
    sizeSmall: {
        width: 125,
        height: 35,
    },
    sizeLarge: {
        width: 280,
        height: 59,
    },
}));

const PrimaryButton = (props) => {
    const {
        onClick,
        children,
        otherProps,
        size,
        disabled,
        type,
        className,
        classes: passedClasses,
        style,
        fullWidth,
    } = props;
    const classes = passedClasses || primaryButtonStyles();
    return (
        <Button
            color={"primary"}
            type={type}
            style={style}
            className={clsx(
                classes.button,
                size === "xs" && classes.sizeXSmall,
                fullWidth && classes.fullWidth,
                className,
            )}
            disabled={disabled}
            classes={{
                text: classes.text,
                textPrimary: classes.textPrimary,
                textSizeSmall: classes.textSizeSmall,
                textSizeLarge: classes.textSizeLarge,
                sizeSmall: classes.sizeSmall,
                sizeLarge: classes.sizeLarge,
            }}
            onClick={(e) => onClick && onClick(e)}
            size={size}
            {...otherProps}
        >
            {children}
        </Button>
    );
};

PrimaryButton.propTypes = {
    onClick: PropTypes.func,
    to: PropTypes.string,
    type: PropTypes.string,
    className: PropTypes.string,
    children: PropTypes.any,
    otherProps: PropTypes.object.isRequired,
    size: PropTypes.oneOf(["small", "medium", "large"]),
    disabled: PropTypes.bool.isRequired,
    color: PropTypes.string.isRequired,
    classes: PropTypes.object,
    style: PropTypes.object,
};

PrimaryButton.defaultProps = {
    otherProps: {},
    style: {},
    size: "medium",
    type: "button",
    color: "primary",
    disabled: false,
};

export default PrimaryButton;
